import { jsx as _jsx } from "react/jsx-runtime";
import { dropKeys, getPropertyUnsafe } from "@bryxinc/ts-utils";
import { Icon } from "@mui/material";
import { styled } from "@mui/system";
import { getModifierPropWithValue } from "../../utility/object";
import { BryxMuiIcons } from "./icons";
function isBryxIconPropsSafe(v) {
    return getPropertyUnsafe(v, "unsafe") != true;
}
const sizeMap = {
    xsm: "11",
    sm: "16",
    md: "20",
    lg: "24",
};
const buildIconProps = (props) => {
    var iconProperties = {};
    Object.entries(props).forEach((entry) => {
        let { key, val } = getModifierPropWithValue(entry);
        if (!key)
            return;
        if (key == "iconSize")
            val = sizeMap[val];
        iconProperties[`${key}`] = val;
    });
    return {
        ...props,
        ...iconProperties,
    };
};
/**
 * Icon definitions are in `icons.ts`.
 * UX states for a `BryxIcon` include:
 *
 * default: Icon to be displayed by default.
 * selected: (optional) Icon to be displayed when selected, fallsback to `default` icon.
 *
 * Other visial states include:
 *
 * hover: `ui` is not responsible for hover states of BryxIcons, that's up to the consuming application. Common use case may be increasing size on hover.
 * disabled: applies the `disabled` color to the icon.
 */
const BryxIcon = styled((props) => {
    const childProps = dropKeys(props, [
        "unsafe",
        "iconName",
        "rippleRef",
        "touchRippleRef",
        "xsmIconSize",
        "smIconSize",
        "mdIconSize",
        "lgIconSize",
    ]);
    if (!isBryxIconPropsSafe(props))
        return _jsx(Icon, { ...childProps, children: props.iconName });
    const iconStates = BryxMuiIcons[props.iconName];
    const DefaultIcon = iconStates.default;
    const SelectedIcon = getPropertyUnsafe(iconStates, "selected");
    if (props.selected && !!SelectedIcon)
        return _jsx(SelectedIcon, { ...childProps });
    return _jsx(DefaultIcon, { ...childProps });
})((props) => {
    const { iconSize } = buildIconProps(props);
    const disabled = getPropertyUnsafe(props, "disabled");
    return {
        ...{
            height: `${iconSize}px`,
            width: `${iconSize}px`,
            fontSize: `${iconSize}px`,
        },
        color: disabled ? "#A1A1A1" : "inherit",
    };
});
export default BryxIcon;
